import { ShoppingCart } from 'lucide-react';
import { Tooltip } from '@/components/ui';
import styles from './CartButton.module.css';
import type { CartButtonProps } from './CartButton.types';

export function CartButton({ itemCount, onClick }: CartButtonProps) {
  return (
    <Tooltip content="Cart" position="bottom">
      <button
        type="button"
        className={styles.cartButton}
        onClick={onClick}
        aria-label={`Shopping cart, ${itemCount} item${itemCount !== 1 ? 's' : ''}`}
      >
        <ShoppingCart size={20} aria-hidden="true" />
        {itemCount > 0 && (
          <span className={styles.badge} aria-hidden="true">
            {itemCount}
          </span>
        )}
      </button>
    </Tooltip>
  );
}
